import { userType } from "const/nuclias/user";
import {
  defaultAccessRoleList,
  defaultAccessLevelTypeList
} from "../const";

import samlRoleExtension from "./extensions/samlRole.js";

class SamlRoleModel {
  static samlRoleState;

  id = 0;
  checked = false;
  name = '';
  role = '';
  accessLevel = '';
  managedScope = [];
  rawData = {};

  constructor(rawData, orgTreeMap, selectedOrg) {
    this.id = rawData.id;
    this.name = rawData.name;

    for (const role of defaultAccessRoleList) {
      if (role.value === rawData.privilege) {
        this.role = role.title;
      }
    }

    for (const accessLevel of defaultAccessLevelTypeList) {
      accessLevel.value === rawData.type && (this.accessLevel = accessLevel.value);
    }

    const managedId = rawData.resources[0].id;
    switch (this.accessLevel) {
      case userType.org:
        for (const siteId in selectedOrg.storeObj) {
          this.managedScope.push(selectedOrg.storeObj[siteId].name);
        }
        break;
      case userType.siteTag:
        for (const siteId in orgTreeMap.withStore) {
          if (orgTreeMap.withStore[siteId].indexOf(managedId) > -1) {
            this.managedScope.push(selectedOrg.storeObj[siteId].name);
          }
        }
        break;
      case userType.site:
        this.managedScope.push(selectedOrg.storeObj[managedId.toString()].name);
        break;
      default:
        return;
    }

    this.rawData = rawData;
  }
}

for (const funcName in samlRoleExtension) {
  SamlRoleModel[funcName] = samlRoleExtension[funcName];
}

export default SamlRoleModel;